import { required, unique, shape, items, concatFailure, fromModel, when, stopOnFirstFailure } from '@totalsoft/pure-validations';
import { uniqueProperty } from 'utils/simple-validations';
import i18next from 'i18next';

export const propertyValidator = shape({
  propertyCode: required,
  propertyName: required,
  propertyTypeId: required
});

export const propertyDetailsValidator = concatFailure(
  unique(x => x.orderNo || {}, 'Property.Validators.OrderNoUnique'),
  items(
    shape({
      propertyValue: required
    })
  )
);

export const propertyUserGroupsValidator = items(
  fromModel(item =>
    shape({
      editValue: shape({
        userGroupId: [required |> when(item.inEdit), uniqueProperty(i18next.t('Property.DuplicatedUserGroup'))] |> stopOnFirstFailure
      })
    })
  )
);
